import { createListFilters, IOption } from '../../../../../components'

export type ImportacoesFilters = {
  empresa?: IOption<number>
  /** Datas puras (aaaa-mm-dd) do <input type="date">. */
  dataInicio: string
  dataTermino: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<ImportacoesFilters>({
  empresa: undefined,
  dataInicio: '',
  dataTermino: '',
})
